<div class="wrapper">
  <div class="sidebar">
    <app-sidebar (listaDeRotas)="atualizarListaDeRotasPermitidas($event)"></app-sidebar>
  </div>
  <div class="main-panel">
      <app-navbar [listaDeRotasPermitidas]="listaDeRotasPermitidas"></app-navbar>
      <div class="content">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
  </div>
</div>

<p-dialog
  [showHeader]="false"
  [visible]="getProgresso().visivel.modal"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  appendTo="body"
  [style]="{width: '350'}">
  <div style="margin: 3em 0; width: 300px; text-align: center">
    <p style="margin-bottom: 1em">{{getProgresso().mensagem}}</p>
    <p-progressBar mode="indeterminate" [style]="{'height': '6px', 'width': '300px'}"></p-progressBar>
  </div>
</p-dialog>

<div
  *ngIf="getProgresso().visivel.modeless"
  style="position: fixed; z-index: 5000; top: 0px; left: 0px; width: 100%;">
  <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
</div>

<p-confirmDialog
  #cd
  header="Confirmação"
  key="global"
  icon="pi pi-question-circle"
  acceptLabel="Sim"
  rejectLabel="Não"
  appendTo="body">
</p-confirmDialog>

<p-toast life="3000" baseZIndex="5001"></p-toast>

<p-dialog
  header="Essa funcionalidade requer que a Fonte de Dados esteja operacional"
  [showHeader]="true"
  [visible]="mostrarErros()"
  [modal]="true"
  [draggable]="false"
  [closable]="false"
  [style]="{width: '90%', maxWidth: '800px'}"
  appendTo="body">
  <div style="width: 100%">
    <div style="text-align: center; margin: 1em 0">
      <p>Clique para expandir e ver os detalhes de cada erro:</p>
      <p-accordion>
        <p-accordionTab *ngFor="let mensagem of fonteDadosMensagemErroService.mensagensDeErro" [header]="mensagem.nome">
          {{ mensagem.erro }}
        </p-accordionTab>
      </p-accordion>
      <button (click)="fecharModalDeErros()" pButton type="button" label="Fechar" class="p-button-danger" style="margin: 1em 0"></button>
    </div>
  </div>
</p-dialog>
